import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-change-phone',
  templateUrl: './change-phone.component.html',
  styleUrls: ['./change-phone.component.css']
})
export class ChangePhoneComponent implements OnInit {
  changePhoneForm: UntypedFormGroup;
  formErrors = {
    'phone': ''

  };
  ValidationMessages = {

    'phone': {
      'required': 'Phone number is Required',
      'minlength': 'Phone number should have a minimum length of 10 characters',
      'maxlength': 'Phone number should only have a maximum length of 10 characters',
      'pattern': 'Only numbers are allowed'
    }
  };
  id: any;
  phone: any;
  api_error: any;
  api_success: string;
  disableConfirmbtn = false;

  constructor(private formbuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private customerService: CustomerService) {
    this.changePhoneForm = this.formbuilder.group({

      phone: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      id: this.data
    });
    console.log(this.id);
  }

  ngOnInit() {
    console.log(this.data);
  }
  logValidationErrors(group: UntypedFormGroup = this.changePhoneForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.ValidationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof UntypedFormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });


  }
  OnSubmit() {
    this.api_error = '';
    this.api_success = '';
    this.logValidationErrors();
    if (this.changePhoneForm.valid) {
      this.disableConfirmbtn = true;
      this.customerService.changePhoneno(this.changePhoneForm.value)
        .subscribe(res => {
          this.api_success = 'Phone number updated successfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
            }, 2000);
        },
          (error) => {
            this.disableConfirmbtn = false;
            this.api_error = error.error;
           }
        );
    }


  }
}
